export const InitialState = {
  isLoggedIn: localStorage.getItem("authToken") ? true : false,
  authToken: localStorage.getItem("authToken"),
};

export type StateType = typeof InitialState;
